"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertError = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const AlertError = ({ size, fill, }) => (react_1.default.createElement(Base_1.Base, { size: size ? size : 16 },
    react_1.default.createElement("path", { fill: fill ? fill : "#FF626D", d: "M7,10L7,12 9,12 9,10 7,10zM7,4L7,9 9,9 9,4 7,4zM5.01,1L10.9,1 15,5.1 15,10.9 10.9,15 5.01,15 1,10.9 1,5.1 5.01,1z" })));
exports.AlertError = AlertError;
//# sourceMappingURL=AlertError.js.map